import { render, staticRenderFns } from "./home_new.vue?vue&type=template&id=6ee61ac2"
import script from "./home_new.vue?vue&type=script&lang=js"
export * from "./home_new.vue?vue&type=script&lang=js"
import style0 from "./home_new.vue?vue&type=style&index=0&id=6ee61ac2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports